/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StudentStrandStatusEnum = "DIAGNOSTIC" | "GROWTH";
export type StudentSkillsMapSubstrandProficiencyIndicator_studentStrandStatus = {
    readonly status: StudentStrandStatusEnum;
    readonly lastWorkedOnDiagnosticCheckIn: {
        readonly endedAt: string | null;
        readonly hasFinishedDiagnosticPhase: boolean;
    } | null;
    readonly " $refType": "StudentSkillsMapSubstrandProficiencyIndicator_studentStrandStatus";
};
export type StudentSkillsMapSubstrandProficiencyIndicator_studentStrandStatus$data = StudentSkillsMapSubstrandProficiencyIndicator_studentStrandStatus;
export type StudentSkillsMapSubstrandProficiencyIndicator_studentStrandStatus$key = {
    readonly " $data"?: StudentSkillsMapSubstrandProficiencyIndicator_studentStrandStatus$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"StudentSkillsMapSubstrandProficiencyIndicator_studentStrandStatus">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StudentSkillsMapSubstrandProficiencyIndicator_studentStrandStatus",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CheckIn",
      "kind": "LinkedField",
      "name": "lastWorkedOnDiagnosticCheckIn",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasFinishedDiagnosticPhase",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StudentStrandStatus",
  "abstractKey": null
};
(node as any).hash = '720bb5b82613554ed201accb58dd10eb';
export default node;
